<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";

export default {
  locales: {
    pt: {},
    es: {},
  },
  components: {
    Layout,
  },
  data() {
    return {
      loading: true,
      loadError: null,
      schedule: null,
    };
  },
  methods: {
    getAgendamento() {
      this.loading = true;
      this.loadError = null;

      api
        .get("telemedicina/agendamentos/" + this.$route.params.id)
        .then((response) => {
          if (response.data.status === "success") {
            this.schedule = response.data.schedule;
          } else {
            this.loadError =
              response.data.message ||
              "Não foi possível carregar o agendamento.";
          }
        })
        .catch(() => {
          this.loadError = "Falha na comunicação com o servidor. Tente novamente.";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // Horário local vindo da RMS (o "Z" não é UTC real): extrai HH:MM por texto, sem usar Date
    timeOf(dateTime) {
      return dateTime && dateTime.length >= 16 ? dateTime.substr(11, 5) : null;
    },
  },
  mounted() {
    this.getAgendamento();
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/telemedicina/agendamentos">Meus Agendamentos</router-link></li>
      <li class="breadcrumb-item">Agendamento</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Agendamento</h3>
        <p>Detalhes da sua consulta online.</p>
      </div>
    </div>

    <b-alert v-if="loadError" show variant="danger">{{ loadError }}</b-alert>

    <div class="card" v-if="loading">
      <div class="card-body">
        <div class="min-vh-25 text-center d-flex justify-content-center align-items-center">
          <b-spinner variant="default" role="status"></b-spinner>
        </div>
      </div>
    </div>

    <div class="row" v-else-if="schedule">
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <div class="mb-4">
              <span class="badge badge-soft-info p-1 px-2 font-size-13 text-uppercase" v-if="schedule.room && schedule.room.status">{{ schedule.room.status }}</span>
              <h4 class="mb-0 mt-2">{{ schedule.specialty }}</h4>
            </div>

            <div class="mb-4">
              <h6 class="text-uppercase text-muted mb-2">Data e horário</h6>
              <div class="border rounded p-3">
                <div class="d-flex justify-content-between mb-1" v-if="schedule.weekday">
                  <span class="text-muted">Dia da semana</span>
                  <strong>{{ schedule.weekday }}</strong>
                </div>
                <div class="d-flex justify-content-between mb-1">
                  <span class="text-muted">Data</span>
                  <strong>{{ schedule.date }}</strong>
                </div>
                <div class="d-flex justify-content-between mb-1">
                  <span class="text-muted">Horário</span>
                  <strong>{{ schedule.time }}</strong>
                </div>
                <div class="d-flex justify-content-between" v-if="timeOf(schedule.datetime_start) && timeOf(schedule.datetime_end)">
                  <span class="text-muted">Duração</span>
                  <strong>{{ timeOf(schedule.datetime_start) }} às {{ timeOf(schedule.datetime_end) }}</strong>
                </div>
              </div>
            </div>

            <div class="mb-4" v-if="schedule.doctor_name">
              <h6 class="text-uppercase text-muted mb-2">Profissional</h6>
              <div class="border rounded p-3">
                <strong>{{ schedule.doctor_name }}</strong>
              </div>
            </div>

            <div>
              <h6 class="text-uppercase text-muted mb-2">Identificação</h6>
              <div class="border rounded p-3">
                <div class="d-flex justify-content-between mb-1" v-if="schedule.id">
                  <span class="text-muted">Protocolo</span>
                  <strong>{{ schedule.id }}</strong>
                </div>
                <div class="d-flex justify-content-between" v-if="schedule.room_id">
                  <span class="text-muted">Sala</span>
                  <strong>{{ schedule.room_id }}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="card">
          <div class="card-body text-center">
            <h5 class="mb-3">Acesso à consulta</h5>
            <template v-if="schedule.room && schedule.room.url">
              <p class="text-muted">Entre na sala no horário agendado.</p>
              <a :href="schedule.room.url" target="_blank" rel="noopener" class="btn btn-default btn-block btn-rounded">
                Entrar na consulta
              </a>
            </template>
            <p class="text-muted mb-0" v-else>Link de acesso indisponível no momento. Tente novamente mais tarde.</p>
            <button v-on:click="getAgendamento()" class="btn btn-link btn-sm mt-2">
              Atualizar
            </button>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
